<div class="mobile-search-wrapper" [ngClass]="{'w-100': showSearchBar}">
  <div class="flex ai_c">
    <span class="search-size material-icons" *ngIf="!showSearchBar" (click)="toggleSearch(true)" type="button"> search </span>
    <ng-container *ngIf="showSearchBar">
      <app-search-input [text]="searchText" (search)="onSearch($event)" (keywordChange)="onInput($event)"></app-search-input>
      <span class="material-icons-outlined ml-2" (click)="toggleSearch(false)" type="button"> close </span>
    </ng-container>
  </div>
</div>